import { isbot } from 'isbot';

export function isCrawler(userAgent: string | null) {
  if (!userAgent) return false;
  return isbot(userAgent);
}

export function isCrawlerClient() {
  if (typeof window === 'undefined') return false;
  return isCrawler(window.navigator.userAgent);
}
